import React from 'react';

/**
 * FormSectionCard — numbered section wrapper for form fields
 * @param {string} number — e.g. "01"
 * @param {string} title — section heading
 * @param {string} description — optional subtitle
 * @param {boolean} optional — mark section as optional
 * @param {React.ReactNode} children — form fields
 */
export const FormSectionCard = ({ number, title, description, optional = false, children }) => {
  return (
    <div className="bg-white border border-[#E5E5E5] rounded overflow-hidden shadow-sm" data-testid={`section-${number}`}>
      {/* Section Header */}
      <div className="px-6 py-4 border-b border-[#E5E5E5] flex items-start gap-4">
        <div className="flex-shrink-0 w-9 h-9 bg-[#0B0B0B] rounded flex items-center justify-center">
          <span className="text-white text-xs font-extrabold tracking-tight">{number}</span>
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h3 className="font-extrabold text-[#0B0B0B] text-base leading-tight">{title}</h3>
            {optional && (
              <span className="text-[10px] text-[#999] border border-[#E5E5E5] px-1.5 py-0.5 rounded font-medium uppercase tracking-wide">
                Opsional
              </span>
            )}
          </div>
          {description && (
            <p className="text-xs text-[#777] mt-0.5">{description}</p>
          )}
        </div>
      </div>
      {/* Section Body */}
      <div className="px-6 py-6">{children}</div>
    </div>
  );
};

export default FormSectionCard;
